import { server_ip } from "../config";

async function fetchPhotoManagementFolders(token,filter={},options={}) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFolders/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                "filter":{...filter},
                "options":{"limit":99,...options}
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function editPhotoManagementFolderRecord(token,_id,data) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFolders/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function createPhotoManagementFolderRecord(token,data) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFolders`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function deletePhotoManagementFolderRecord(token,id) {
    try {
        const response = await fetch(`${server_ip}/api/photoManagementFolders/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}

export{
    fetchPhotoManagementFolders,
    editPhotoManagementFolderRecord,
    createPhotoManagementFolderRecord,
    deletePhotoManagementFolderRecord,
}